<template>
  <avtalat-icon
    class="spin-counter inline-block"
    id="uppdatering"
    :size="20"
  />
</template>

<style scoped>
@keyframes spinCounterClockwise {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

.spin-counter {
  display: inline-block;
  animation: spinCounterClockwise 1.5s linear infinite;
}
</style>
